module.exports = __webpack_public_path__ + "static/media/ssangyong.f7ec21e9.png";